import { WithOwner } from "../IDBSchema";
import { LocalLoginUser } from "../../../schema/console/loginUser";
import { getUserType, localUserSchema, localUserType } from "../../../schema/console/user";
import { getFromIdPayload } from "../../../schema/general";
import { EntityDataApi, IndexedDBApi } from "../IndexedDBApi";
import { IDBEntityDef } from "../generated/entityDefs";
import Time from "../../../util/Time";

// Userはパスワード等の認証情報を除いたlocalUser型で保存するため、
// 自動生成のentityDefsではなく手書きの定義を使う。
export const localUserDef: IDBEntityDef = {
  name: "User",
  store: "Users",
  collectKeys: ["User", "Users"],
  schema: localUserSchema,
  putDefaults: {},
  hasPreparer: false,
  indexes: [],
};

export class LocalUserDataApi extends EntityDataApi<localUserType> {
  public readonly def = localUserDef;

  public async getById(payload: WithOwner<getFromIdPayload>): Promise<localUserType | null> {
    const data = await this.readByKey(payload.id, payload.ownerId);
    return data ?? null;
  }

  public async getAll(): Promise<localUserType[]> {
    return await this.readAll();
  }

  // ログインしたユーザー自身をキャッシュする(所属Groupも併せて保存)
  public async cacheLoginUser(payload: WithOwner<LocalLoginUser>) {
    const currentTime = Time.Now().GetTime();
    const userPutData = {
      ...localUserSchema.parse(payload),
      ownerId: payload.ownerId,
      cachedAt: currentTime,
    };
    await this.writeRow(userPutData);
    await this.IDB().groupDataApi.cache({ ...payload.Group, cachedAt: currentTime, ownerId: payload.ownerId });

    return { status: "ok" };
  }

  public async getFullDataById(payload: WithOwner<getFromIdPayload>): Promise<getUserType> {
    const userData = await this.getById(payload);
    if (!userData) {
      throw new Error("ユーザーデータがローカルDBにありません。");
    }
    const group = await this.IDB().groupDataApi.getById({ id: userData.group_id, ownerId: payload.ownerId });
    return { ...userData, Group: group };
  }
}

export class LoginUserDataApi extends IndexedDBApi {
  static readonly dataTable = "LoginUsers";
  private readonly table = LoginUserDataApi.dataTable;

  public async getAll(): Promise<LocalLoginUser[]> {
    const tx = this.db.transaction(this.table, "readonly");
    const allData = await tx.objectStore(this.table).getAll();
    await tx.done;
    return allData;
  }

  public async get(id: string): Promise<LocalLoginUser> {
    const tx = this.db.transaction(this.table, "readonly");
    const data = await tx.objectStore(this.table).get(id);
    await tx.done;
    return data;
  }

  public async put(putData: LocalLoginUser) {
    const tx = this.db.transaction(this.table, "readwrite");
    await tx.objectStore(this.table).put(putData);
    await tx.done;

    await this.IDB().userDataApi.cacheLoginUser({ ...putData, ownerId: putData.id });
  }

  public async Delete(id: string) {
    const tx = this.db.transaction(this.table, "readwrite");
    await tx.objectStore(this.table).delete(id);
    await tx.done;
  }
}
